import React from "react";
import { useLang } from "@/context/LangContext";

// Pre-login interface-language selector (EN / DE only). Sets appLanguage,
// which immediately controls ALL interface text and persists via localStorage.
export function AppLangToggle({ dark = false }) {
  const { lang, setLang, langs } = useLang();
  return (
    <div
      data-testid="app-lang-toggle"
      className="inline-flex items-center gap-1 rounded-full p-1"
      style={{
        background: dark ? "rgba(255,255,255,0.18)" : "rgba(37,99,235,0.08)",
        backdropFilter: "blur(8px)", WebkitBackdropFilter: "blur(8px)",
        border: dark ? "1px solid rgba(255,255,255,0.35)" : "1px solid rgba(37,99,235,0.18)",
      }}
    >
      {langs.map((l) => {
        const active = lang === l.code;
        return (
          <button
            key={l.code}
            type="button"
            data-testid={`app-lang-${l.code}`}
            onClick={() => setLang(l.code)}
            className="px-3 py-1.5 rounded-full text-xs font-bold transition-colors"
            style={{
              background: active ? "#2563EB" : "transparent",
              color: active ? "#ffffff" : dark ? "rgba(255,255,255,0.92)" : "#334155",
            }}
          >
            {l.flag} {l.code.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}

export default AppLangToggle;
